import type { Settings } from '../types/settings'

export const useSettings = () => useState<Settings | null>('settings', () => ({
  mainApiMaintenanceMode: false,
} as Settings))

export const updateSettings = async (settingsResponse: Settings | null) => {
  const settings = useSettings()
  settings.value = {
    mainApiMaintenanceMode: settingsResponse?.mainApiMaintenanceMode || false,
  }
}

export const useGetLoginURL = () => {
  const route = useRoute()
  return `/login?platform_redirect=${route.path}`
}

export const useDebugMode = () => useState<boolean | null>('debug-mode', () => false)

export const useDebugModeListener = () => {
  const allowedEnvs = ['LOCAL', 'DEV', 'REL']
  const runtimeConfig = useRuntimeConfig()
  if (process.client && allowedEnvs.includes(runtimeConfig.public.environment)) {
    (window as any).enableDebug = () => {
      const debug = useDebugMode()
      debug.value = true
    }
    (window as any).disableDebug = () => {
      const debug = useDebugMode()
      debug.value = false
    }
  }
}
